var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlus = function SvgPlus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.994 62a7.554 7.554 0 0 1-7.529-7.536V38.529H7.536a7.533 7.533 0 1 1 0-15.065h15.935V7.536a7.53 7.53 0 1 1 15.059 0v15.935h15.934a7.533 7.533 0 1 1 0 15.065H38.529v15.935A7.55 7.55 0 0 1 30.994 62"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export default ForwardRef;